module.exports = __webpack_public_path__ + "img/index-svg-white.6ce6b800.svg";